import type { Translate } from "app/filters/i18nFilter";
import type { ExportName } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { ExportTabs } from "app/pages/sales-intelligence/common-components/export-table/constants";

import {
    EXPORT_TAB_ACCOUNTS_TITLE,
    EXPORT_TAB_CONTACTS_TITLE,
    EXPORT_TAB_LEADS_TITLE,
} from "../translations/translations";

export const getExportTabsDisplayNames = (integrationName: Integration, translate: Translate) => [
    translate(EXPORT_TAB_ACCOUNTS_TITLE[integrationName]),
    translate(EXPORT_TAB_CONTACTS_TITLE),
    translate(EXPORT_TAB_LEADS_TITLE),
];

export const tabIndexToExportName = (tabIndex: ExportTabs, isCompanyAsLeadExportClaimEnabled: boolean): ExportName => {
    const tabToExportName = {
        [ExportTabs.account]: "accounts",
        [ExportTabs.contact]: "contacts",
        [ExportTabs.lead]: isCompanyAsLeadExportClaimEnabled ? "companyAsLeads" : "leads",
    } as const;

    return tabToExportName[tabIndex];
};

export const exportNameToTabIndex = (exportName: ExportName): ExportTabs => {
    const exportNameToTab = {
        accounts: ExportTabs.account,
        contacts: ExportTabs.contact,
        leads: ExportTabs.lead,
        companyAsLeads: ExportTabs.lead,
    } as const;

    return exportNameToTab[exportName];
};
